export default __webpack_public_path__ + "static/media/hills-no-notch.1fff5a19.svg";